'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _find2 = require('lodash/find');
var _find3 = _interopRequireDefault(_find2);
var _isUndefined2 = require('lodash/isUndefined');
var _isUndefined3 = _interopRequireDefault(_isUndefined2);
var _isNil2 = require('lodash/isNil');
var _isNil3 = _interopRequireDefault(_isNil2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _isEmpty2 = require('lodash/isEmpty');
var _isEmpty3 = _interopRequireDefault(_isEmpty2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _reject2 = require('lodash/reject');
var _reject3 = _interopRequireDefault(_reject2);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function (dimensions, ids) {
  if ((0, _isEmpty3.default)(dimensions)) return;
  var chartDimension = void 0;
  var id = (0, _get3.default)(ids, 'id');
  if (!(0, _isNil3.default)(id)) chartDimension = (0, _find3.default)(dimensions, {
    id: id
  });
  if ((0, _isUndefined3.default)(chartDimension)) {
    var _dimensions = (0, _reject3.default)(dimensions, _dotstatsuiteSdmxjs.isRefAreaDimension);
    chartDimension = (0, _head3.default)((0, _isEmpty3.default)(_dimensions) ? dimensions : _dimensions);
  }
  var chartDimensionId = (0, _get3.default)(chartDimension, 'id');
  var values = (0, _get3.default)(chartDimension, 'values', []);
  var xValue = (0, _find3.default)(values, function (value) {
    return value.id === (0, _get3.default)(ids, 'xId', null);
  });
  var yValue = (0, _find3.default)(values, function (value) {
    return value.id === (0, _get3.default)(ids, 'yId', null) && value.id !== xId;
  });
  //if same xId & yId provided, xId is taken in account
  var xId = (0, _isUndefined3.default)(xValue) ? (0, _head3.default)((0, _isUndefined3.default)(yValue) ? values : (0, _reject3.default)(values, yValue)).id : xValue.id;
  var yId = (0, _isUndefined3.default)(yValue) ? (0, _find3.default)(values, function (value) {
    return value.id !== xId;
  }).id : yValue.id;
  return {
    id: chartDimensionId,
    xId: xId,
    yId: yId
  };
};